var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseExistDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 190,
    viewBox: "0 0 299 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3041_44774)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 190,
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 47.2253C115.5 38.8738 125.478 29.9998 148.5 30C167 30.0002 223.722 41.0319 210.598 73.9846C197.474 106.937 231.276 78.2304 249.625 119.97C252.284 126.027 253.563 132.643 253.365 139.301C253.134 146.337 251.397 153.229 248.282 159.473C242.422 171.414 235.073 180.697 222 186.594",
    stroke: "#D2D2FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135 189.207L48.5081 94.7734L48.5078 189.207H135ZM95.0272 172.413L65.6354 141.577L65.6353 172.413H95.0272Z",
    fill: "#0B2456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 150.121,
    x2: 51.0541,
    y2: 150.121,
    stroke: "#F9F9FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 162.121,
    x2: 53.4054,
    y2: 162.121,
    stroke: "#F9F9FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 138.121,
    x2: 53.4054,
    y2: 138.121,
    stroke: "#F9F9FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 174.121,
    x2: 51.0541,
    y2: 174.121,
    stroke: "#F9F9FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M102.35 69.0481C102.199 69.9064 101.815 70.7024 101.244 71.3426C100.968 71.6709 100.66 71.9688 100.326 72.2317C100.149 72.3636 99.2195 73.1553 99.026 73.052C97.7816 72.4038 96.2164 70.7575 96.0228 69.1686C95.9924 68.9191 95.9924 68.6666 96.0228 68.4171C96.0933 67.9822 96.3129 67.5883 96.6411 67.308C96.9693 67.0276 97.3842 66.8796 97.8092 66.8913C98.0841 66.9047 98.3523 66.9836 98.593 67.1219C98.8338 67.2602 99.0406 67.4541 99.1974 67.6886C99.4397 67.3743 99.7743 67.1508 100.15 67.0518C100.526 66.9529 100.923 66.984 101.281 67.1405C101.638 67.2969 101.937 67.5702 102.131 67.9186C102.325 68.2671 102.403 68.6718 102.355 69.0711L102.35 69.0481Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73 71.1211H195V151.121C195 157.749 189.627 163.121 183 163.121H89C80.1634 163.121 73 155.958 73 147.121V71.1211Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.241 53.1211H89.0356C78.1477 53.1211 73 58.676 73 68.9081V145.806C73 156.038 78.1477 163.121 89.0356 163.121H181.241C192.129 163.121 195 156.038 195 145.806V70.4359C195 60.2038 192.129 53.1211 181.241 53.1211Z",
    stroke: "#273754",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 80.5859H88.2022C85.37 80.5859 83.0684 83.1363 83.0684 86.2765V143.683C83.0684 146.829 85.37 149.381 88.2022 149.381H109.044C111.876 149.381 114.187 146.829 114.187 143.683V86.2765C114.187 83.1363 111.883 80.5859 109.044 80.5859ZM111.761 142.084C111.761 144.708 109.846 146.829 107.478 146.829H89.7713C87.4036 146.829 85.489 144.708 85.489 142.084V87.8885C85.489 85.2661 87.4036 83.1441 89.7713 83.1441H107.475C109.842 83.1441 111.757 85.2661 111.757 87.8885L111.761 142.084Z",
    fill: "#D5D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.832 95.5683L124.972 114.102C125.007 117.333 126.337 120.426 128.684 122.734C131.031 125.041 134.213 126.385 137.565 126.483L156.621 126.802C158.256 126.823 159.878 126.527 161.392 125.933C162.906 125.338 164.281 124.458 165.436 123.343C166.591 122.228 167.502 120.901 168.115 119.441C168.729 117.98 169.033 116.417 169.008 114.841L168.863 96.3125C168.833 93.078 167.506 89.9802 165.158 87.6683C162.811 85.3565 159.625 84.0102 156.27 83.9116L137.214 83.5878C135.578 83.5682 133.954 83.8651 132.44 84.4608C130.925 85.0566 129.55 85.9391 128.395 87.0562C127.241 88.1732 126.33 89.5021 125.718 90.9642C125.106 92.4263 124.805 93.9919 124.832 95.5683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.76 100.216L127.86 113.632C127.891 116.439 129.047 119.127 131.087 121.132C133.126 123.136 135.891 124.304 138.803 124.39L155.352 124.665C156.773 124.686 158.184 124.431 159.501 123.916C160.818 123.401 162.014 122.637 163.019 121.668C164.024 120.7 164.817 119.547 165.351 118.278C165.886 117.009 166.15 115.649 166.129 114.28V113.371C163.807 108.795 159.284 101.946 154.459 106.04C147.504 111.931 144.319 107.446 140.267 101.666C136.852 96.8286 131.707 93.2958 127.76 100.216Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.866 98.3678C160.965 97.0237 161.507 94.2508 160.075 92.1744C158.644 90.0981 155.781 89.5044 153.682 90.8485C151.583 92.1926 151.041 94.9655 152.473 97.0419C153.904 99.1183 156.767 99.7119 158.866 98.3678Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.7294,
    cy: 62.1044,
    r: 3.66102,
    fill: "#0B2456"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7118,
    cy: 62.1044,
    r: 3.66102,
    fill: "#0B2456"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.694,
    cy: 62.1044,
    r: 3.66102,
    fill: "#0B2456"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.875,
    y: 135.5,
    width: 27.386,
    height: 2.55118,
    rx: 1.27559,
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.584,
    y: 140.947,
    width: 32.8458,
    height: 2.55118,
    rx: 1.27559,
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.709,
    y: 146.396,
    width: 31.9098,
    height: 2.55118,
    rx: 1.27559,
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.239 137.959C149.958 138.365 149.541 138.674 149.051 138.839C148.561 139.004 148.025 139.016 147.528 138.872C147.03 138.729 146.597 138.438 146.296 138.044C145.995 137.651 145.843 137.177 145.863 136.696C145.874 136.408 145.946 136.125 146.075 135.862C146.204 135.6 146.389 135.364 146.617 135.167C146.845 134.97 147.114 134.817 147.406 134.717C147.699 134.616 148.01 134.569 148.322 134.58C148.634 134.589 148.942 134.655 149.226 134.774C149.511 134.894 149.767 135.064 149.98 135.275C150.193 135.485 150.359 135.733 150.468 136.004C150.577 136.274 150.627 136.561 150.615 136.849C150.599 137.244 150.469 137.627 150.239 137.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.202 143.722C156.975 143.973 156.69 144.174 156.368 144.31C156.046 144.446 155.696 144.514 155.342 144.509C154.988 144.505 154.639 144.427 154.322 144.282C154.005 144.137 153.727 143.928 153.508 143.671C153.159 143.265 152.979 142.757 153.002 142.239C153.016 141.933 153.097 141.633 153.239 141.357C153.44 140.975 153.757 140.655 154.151 140.436C154.545 140.217 154.999 140.108 155.459 140.122C155.902 140.135 156.332 140.262 156.7 140.49C157.068 140.718 157.358 141.038 157.538 141.412C157.692 141.718 157.765 142.054 157.75 142.392C157.736 142.88 157.542 143.349 157.202 143.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.228 148.877C142.943 149.276 142.524 149.578 142.035 149.737C141.547 149.897 141.015 149.905 140.521 149.76C140.027 149.615 139.598 149.325 139.299 148.935C138.999 148.544 138.846 148.074 138.863 147.596C138.878 147.214 139.001 146.841 139.218 146.515C139.435 146.194 139.739 145.93 140.1 145.748C140.46 145.567 140.865 145.475 141.276 145.481C141.686 145.486 142.088 145.59 142.443 145.781C142.797 145.972 143.092 146.244 143.299 146.572C143.527 146.929 143.638 147.339 143.62 147.753C143.603 148.154 143.468 148.542 143.228 148.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.363 85.9902C139.463 85.844 139.591 85.6907 139.698 85.5374C139.804 85.384 139.939 85.2378 140.064 85.0916C140.47 84.637 140.911 84.2159 141.38 83.8321C141.528 83.7094 141.676 83.5962 141.824 83.4854L139.363 85.9902Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.394 157.64L216.285 157.6",
    stroke: "#273754",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.77 102.81V102.803",
    stroke: "#273754",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.088 190.066H225.454H225.501H235.805",
    stroke: "#273754",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.77 190.057L48.5 190.058",
    stroke: "#273754",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.526 52.5008L187.408 92.8307C182.977 97.0735 179.658 102.357 177.766 108.18L173.821 120.317L188.343 114.507C192.649 112.784 196.607 110.241 199.996 107.02L242.598 66.5282C244.875 64.3649 246.027 61.2667 245.703 58.184C245.378 55.1014 243.616 52.4022 240.955 50.9144C237.288 48.8632 232.653 49.5065 229.526 52.5008Z",
    fill: "#EE4360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.754 115.931L188.715 113.15C193.04 111.42 197.017 108.869 200.423 105.638L243.237 65.0359",
    stroke: "#273754",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.822 120.317L182.348 116.906C180.889 114.309 178.869 112.129 176.474 110.567L173.822 120.317Z",
    fill: "#273754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9775 163.714C38.9775 163.714 22.0011 140.97 22 119.423C21.9993 106.066 28.136 94.4609 38.9775 88.2985C51.7548 81.0358 57.3719 86.7198 68 73.9336",
    stroke: "#D2D2FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3041_44774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseExistDesign);
export default __webpack_public_path__ + "static/media/use-exist-design.eb3c18eb.svg";
export { ForwardRef as ReactComponent };